var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.prependText))]),(_vm.hasIcon)?_c(_vm.preview.icon,{tag:"component",staticClass:"conversation-item__preview-icon"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.preview.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }